"use strict";exports.__esModule=true;exports.default=void 0;function interpolateNumber(_min,_max){var min=Number(_min),max=Number(_max),diff=max-min;return function(ratio){return diff*ratio+min}}var _default=interpolateNumber;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/scale-utils/interpolators/number.js
// module id = O+zb
// module chunks = 5